export enum ETipoControleProducao {
    Outros = 1,
    Densidade = 2,
    PH = 3
}
